import React from 'react'
import { withTranslation } from "react-i18next";

const Title = (props) => {
  const { t } = props;

  return (
    <h3>{t(props.title)}</h3>
  )
};

export default withTranslation()(Title);

